var FcLocationsInputModule = /** @class */ (function () {
    function FcLocationsInputModule() {
    }
    return FcLocationsInputModule;
}());
export { FcLocationsInputModule };
